import { useQuery } from "@tanstack/react-query";
import { getAllNotification } from "../../services/notification";


const useGetNotifications = () => {
    return useQuery({
        queryKey: ["notifications"],
        queryFn: getAllNotification,
        staleTime: Infinity,
    });
}

export default useGetNotifications
;